module.exports = __webpack_public_path__ + "img/category-unknown.d2c82089.svg";